import { Dropdown, DefaultDropdownProps } from 'framework/form';
import { getSourceOptions } from 'domain/recruiting/candidate/applications/shared/candidateApplicationService';

const CandidateApplicationSourceDropdown = ({
  label: labelInput = 'Candidate Application Source',
  ...props
}: DefaultDropdownProps) => {
  return (
    <Dropdown
      placeholder="Choose Candidate Application Source"
      options={Object.entries(getSourceOptions()).map(entry => {
        const [value, label] = entry;
        return {
          value,
          label,
        };
      })}
      label={labelInput}
      {...props}
    />
  );
};

export default CandidateApplicationSourceDropdown;
